module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/tp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/c25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/authorsnote",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Material")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Padma Celebrates Buy Day")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labor in SF, or Make the Robots Do It")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Strike I Ever Saw")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Idea - The Cloud Goes On Strike")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Favorite Bit - John Galt’s Powerpoint")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sci Fi Bulletin - Writing About Politics and Other Professional Hazards")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SFF World - Writing Women Characters (Wait, Aren't You a Dude?)")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/end09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Lime Chicken Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/alsoby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Adam Rakunas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0